export default __webpack_public_path__ + "static/media/FreeText_qr_icon_disabled.cad9c3ea.svg";